/**
 * Created by tmorone on 2/8/2016.
 */

var Marionette = require('backbone.marionette');

/**
 * Renders an individual row of the leaderboard table.
 */
var LeaderboardRow = Marionette.LayoutView.extend({
    template: require('../templates/LeaderboardRow.html'),
    tagName: 'tr'
});

/**
 * The leaderboard page view. This is a CompositeView that uses a child view to render each row of the leaderboard.
 */
module.exports = Marionette.CompositeView.extend({
    template: require('../templates/LeaderboardBody.html'),
    childView: LeaderboardRow,
    childViewContainer: '#leaderboard-body',
    modelEvents: {
        sync: 'render'
    },
    collectionEvents: {
        sync: 'render'
    },

    initialize: function() {
        this.model.fetch();
        this.collection.fetch();
    }
});
